module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "uzm4F59whZiM9YRiq8s8aF2"
    }
  }, [_c('p', {
    staticClass: "CHAPTER1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Thanks to the music of "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("Neil Finn, Radiohead, Spoon,")]), _vm._v(" and "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("U2")]), _vm._v(" that helped inspire my long hours of writing. Thanks to the cast and crew of my favorite shows – "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("For All Mankind, The Expanse, Breaking Bad, Better Call Saul, ")]), _vm._v("and many more. To the podcasts and content creators I enjoyed when I needed a break "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("The Bearded Ones, Stephen Colbert, Seth Meyers, Jimmy Kimmel, I Hate It but I Love It, The Why Files, ")]), _vm._v("and anything "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("Alex Schmidt ")]), _vm._v("does. Thanks to beta-readers like "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("Jay, Mark, Matthew,")]), _vm._v(" and "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("Vinny")]), _vm._v(". To "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("Elijah Toten")]), _vm._v(" for the kickass cover and finally to "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("Rowe Carenen")]), _vm._v(" for the fabulous editing job! Buckle up Rowe!")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-Space",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("And last but not least, thanks to "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("Kedakai! ... As God Made Her.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ebb9e9c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ack.vue
// module id = 75
// module chunks = 0